import { render, staticRenderFns } from "./NuevoTipo.vue?vue&type=template&id=13d8baca&"
import script from "./NuevoTipo.vue?vue&type=script&lang=js&"
export * from "./NuevoTipo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports